export const reports = reportsApi => ({
  challengeReport(id, data, success, fail) {
    reportsApi.authenticatedRequest('POST', `/challenges/${id}`, data, success, fail);
  },
  challengeAssessmentReport(id, data, success, fail) {
    reportsApi.authenticatedRequest('POST', `/challenges/${id}/assessments`, data, success, fail);
  },
  individualAssessorReport(id, success, fail) {
    reportsApi.authenticatedRequest('GET', `/challenges/${id}/assessments/individual`, null, success, fail);
  },
  pollReport(id, data, success, fail) {
    reportsApi.authenticatedRequest('POST', `/polls/${id}`, data, success, fail);
  },
  companyDirectoryReport(type, id, data, success, fail) {
    reportsApi.authenticatedRequest('POST', `/groups/${id}/companies?format=${type}`, data, success, fail);
  },
  orgReport(id, data, success, fail) {
    reportsApi.authenticatedRequest('POST', `/organisations/${id}`, data, success, fail);
  },
  ipAgreementReport(id, data, success, fail) {
    reportsApi.authenticatedRequest('GET', `/ipStatement/${id}`, data, success, fail);
  },
});
